/// <amd-module name="SuiteCommerce.LookBook.Common.Configuration"/>
define("SuiteCommerce.LookBook.Common.Configuration", ["require", "exports"], function (require, exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.Configuration = void 0;
    var environment = null;
    var Configuration = /** @class */ (function () {
        function Configuration() {
        }
        Object.defineProperty(Configuration, "environment", {
            set: function (environmentComponent) {
                environment = environmentComponent;
            },
            enumerable: false,
            configurable: true
        });
        Configuration.get = function (key, defaultValue) {
            if (environment) {
                return environment.getConfig(key);
            }
            console.error('Please set the Environment Component in the Configuration.');
            return null;
        };
        Object.defineProperty(Configuration, "displayLookBookSlide", {
            get: function () {
                return this.get('lookBook.displayLookBookSlide');
            },
            enumerable: false,
            configurable: true
        });
        Object.defineProperty(Configuration, "lookSubtitle", {
            get: function () {
                return this.get('lookBook.lookSubtitle', 'Shop The Look');
            },
            enumerable: false,
            configurable: true
        });
        Object.defineProperty(Configuration, "lookDetailsTitle", {
            get: function () {
                return this.get('lookBook.lookDetailsTitle', 'Details');
            },
            enumerable: false,
            configurable: true
        });
        Object.defineProperty(Configuration, "bxSliderDefault", {
            get: function () {
                return this.get('bxSliderDefaults');
            },
            enumerable: false,
            configurable: true
        });
        Object.defineProperty(Configuration, "siteSettingsImageSizes", {
            get: function () {
                return this.get('siteSettings.imagesizes');
            },
            enumerable: false,
            configurable: true
        });
        Object.defineProperty(Configuration, "imageSizeMappingThumbnail", {
            get: function () {
                return this.get('imageSizeMapping.thumbnail');
            },
            enumerable: false,
            configurable: true
        });
        Object.defineProperty(Configuration, "pdpSectionTitle", {
            get: function () {
                return this.get('lookBook.pdpSectionTitle', 'Look Good With');
            },
            enumerable: false,
            configurable: true
        });
        Object.defineProperty(Configuration, "isEnvironmentBrowser", {
            get: function () {
                return this.get('jsEnvironment') === 'browser';
            },
            enumerable: false,
            configurable: true
        });
        Object.defineProperty(Configuration, "isEnvironmentTouchEnabled", {
            get: function () {
                return this.get('isTouchEnabled');
            },
            enumerable: false,
            configurable: true
        });
        return Configuration;
    }());
    exports.Configuration = Configuration;
});
